
import LinkCircle from "../../../assets/filled/LinkCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LinkCircleIcon({ className, dataTestid = "LinkCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LinkCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
